import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class ConsoleUserService {

    constructor(private http: HttpClient) { }

    // Get All Console Users
    public getAllConsoleUsers() {

        // let paginationString = '';
        // paginationString += '?size=' + pagination.size;
        // paginationString += '&page=' + pagination.page;

        // const sortString = '&sort=' + sort;

        // return this.http.get(environment.apiUrl + 'api/ext-console-user' + paginationString + sortString, { observe: 'response' })
        return this.http.get(environment.apiUrl + 'api/ext-console-user')
            .pipe(map(this.handleDataWithHeaders))
            .pipe(catchError(this.handleError));
    }

    // Get User by User ID
    public getConsoleUserById(id) {
        return this.http.get(environment.apiUrl + 'api/ext-console-user/' + id)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Get Console User by Store
    public getConsoleUsersByStore(storeid) {
        return this.http.get(environment.apiUrl + 'api/ext-console-user/by-store/' + storeid)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Create User
    public createConsoleuser(obj) {
        return this.http.post(environment.apiUrl + 'api/ext-console-user', obj)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // Edit User
    public editConsoleUser(obj) {
        return this.http.put(environment.apiUrl + 'api/ext-console-user', obj)
            .pipe(map(this.handleData))
            .pipe(catchError(this.handleError));
    }

    // HANDLE DATA
    private handleData(res: HttpResponse<any>) {
        const body = res;
        return body;
    }


    public handleDataWithHeaders(res: HttpResponse<any>) {

        const headers = res.headers;
        const body = res.body;
        const data = {
            'headers': headers,
            'body': body
        };
        return data;
    }


    private handleError(error: any) {
        return Observable.throw(
            new HttpErrorResponse(error)
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/_services/console-user.service.ts